export const FIDELITY_CARD_TYPES = [
  { value: 'leclerc',     label: 'Leclerc' },
  { value: 'auchan',      label: 'Auchan' },
  { value: 'carrefour',   label: 'Carrefour' },
  { value: 'u',           label: 'U' },
  { value: 'intermarche', label: 'Intermarché' },
] as const

export type FidelityCardTypeValue = (typeof FIDELITY_CARD_TYPES)[number]['value']

export function fidelityCardLabel(type: string): string {
  return FIDELITY_CARD_TYPES.find(t => t.value === type)?.label ?? type
}
